
import { UIConfigurationData } from "../data/ui-configuration";
import { UIConfiguration } from "../models/ui-configuration-Models";

const get = (): UIConfiguration|undefined => {
  return  UIConfigurationData;
};


const UIConfigurationHelper = {

    get,
    
}

export default UIConfigurationHelper;